import * as React from 'react';
import { useDispatch } from 'react-redux';

import { useFiltersContext } from '../../../packages/Filters/shared/utils/useFiltersContext';
import { resetTerms, TJsonQueryOptionalKeys } from '../../../packages/JsonQuery';
import { justChangeJsonQuery } from '../../common/actions/filters/justChangeJsonQuery';
import { LOCAL_STORAGE_IS_MOBILE_FILTERS_WERE_APPLIED } from '../../common/hooks/useUxFbPoll/constants';
import {
  getLocalStorageFiltersWereAppliedTwoTimes,
  setLocalStorageFiltersApplied,
} from '../../common/hooks/useUxFbPoll/localStorageUtils';

export function useChip(termsToReset: TJsonQueryOptionalKeys[]) {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const { jsonQuery, onApply, onApplyClick: onApplyClickFromContext } = useFiltersContext();
  const prevJsonQuery = React.useRef(jsonQuery);
  const isLocalStorageFiltersWereAppliedTwoTimes = getLocalStorageFiltersWereAppliedTwoTimes(
    LOCAL_STORAGE_IS_MOBILE_FILTERS_WERE_APPLIED,
  );

  React.useEffect(() => {
    if (open) {
      prevJsonQuery.current = jsonQuery;
    }
  }, [open]);

  const onChipClick = React.useCallback(() => {
    setOpen(true);
  }, []);

  const onClose = React.useCallback(() => {
    setOpen(false);
  }, []);

  const onReset = React.useCallback(() => {
    const nextJsonQuery = resetTerms(termsToReset)(jsonQuery);
    dispatch(justChangeJsonQuery({ nextJsonQuery }));
  }, [dispatch, jsonQuery]);

  const onCloseWithReset = React.useCallback(() => {
    dispatch(justChangeJsonQuery({ nextJsonQuery: prevJsonQuery.current }));
    onClose();
  }, [dispatch, onClose]);

  const onApplyClick = React.useCallback(() => {
    onClose();
    onApply();
    if (onApplyClickFromContext) {
      onApplyClickFromContext();
    }

    //Если фильтр был применен 2 раза, сохраняем значеине в LocalStorage
    if (!isLocalStorageFiltersWereAppliedTwoTimes) {
      setLocalStorageFiltersApplied(LOCAL_STORAGE_IS_MOBILE_FILTERS_WERE_APPLIED);
    }
  }, [onApply, onClose, isLocalStorageFiltersWereAppliedTwoTimes, setLocalStorageFiltersApplied]);

  return React.useMemo(
    () => ({
      open,
      onChipClick,
      onReset,
      onCloseWithReset,
      onApplyClick,
    }),
    [open, onChipClick, onReset, onCloseWithReset, onApplyClick],
  );
}
